<template>
	<div class="tk-upload-audio">
		<div class="tk-audio">
			<div  
				class="tk-audio-item"
				v-for="(item,index) of nativeVal" 
				@click="playAudio(item)"
			></div>
		</div>
		
		<div class="tk-upload-audio-main">
			<div 
				@touchstart="pressToSay($event,0)" 
				@touchmove="pressToSay($event,1)"
				@touchend="pressToSay($event,2)" 
				class="button">
				按住此处录音
			</div>
		</div>
		<div v-if="audioStatus!='0'" class="pressToSay-box">
			{{audioStatus=='1'?'手指右滑 取消发送':'松开手指 取消发送'}}
		</div>
	</div>
</template>

<script>
	import playAudio from './playAudio.js';
	import {createFile,captureVideo} from './file.js';
	export default{
		data(){
			return {
				audioStatus:"0",
				audioVal:this.value||[],
				nativeVal:[]
			}
		},
		props:{
			value:{
				type:Array,
				default:()=>[]
			}
		},
		watch:{
			value(newVal){
				this.tkValue=newVal
			},
			audioVal(newVal){
				this.$emit('input',newVal)
			}
		},
		methods:{
			playAudio(src){
				playAudio(src);
			},
			pressToSay(e,i){
				e.stopPropagation();
				var that=this;
				var timer;
				function release(){
					if(that.audioStatus=="1"){
						createFile.stop();
					}else if(that.audioStatus=="2"){
						createFile.cancel();
					};
					that.audioStatus="0";
					release.hasRelease=true;
				}
				[()=>{//开始
					this.audioStatus="1";
					release.hasRelease=false;//表面还未释放资源
					this.startx=e.changedTouches[0].pageX;
					this.timeStart=new Date().getTime();
					createFile(new Date().getTime()+'.wav',function(d,url){
						that.audioVal.push(d);
						that.nativeVal.push(url)
					});
					timer=setTimeout(()=>{
						release();
					},30000);
				},()=>{//移动
					var movedx=e.changedTouches[0].pageX-this.startx;
					var outBox=movedx>50||(movedx<-50);
					if(outBox){
						this.audioStatus="2";
					}else if(this.audioStatus!=1){
						this.audioStatus="1";
					}
				},()=>{
					//超过30秒以及释放过了
					if(release.hasRelease) return;
					//没到30秒的时候；松开时清除timer；并释放资源
					if(timer){
						clearTimeout(timer);
						timer=null;
					}
					release();
				}][i]();
			}
		}
	}
</script>

<style lang="less">
	.tk-audio{
		overflow: hidden;
		position:static;
		.tk-audio-item{
			margin-left:10px;
			background:#fff;
			width:100px;
			height:30px;
			float: left;
		}
	}
	.tk-upload-audio{
		
	}
	.button{
		width:150px;
		color:#fff;
		height:40px;
		background:#fcbd3a;
		border-radius:5px;
		text-align: center;
		line-height: 40px;
	}
	.pressToSay-box{
		width:200px;
		height:200px;
		position:fixed;
		margin:auto;
		left:0;
		right:0;
		bottom:0;
		top:0;
		border-radius:10px;
		background:rgba(0,0,0,.5);
		text-align: center;
		line-height:200px;
		font-size:20px;
		color:#fff;
	}
</style>